import React from 'react';
import {Modal,Button, Row} from "antd";
import language from "../../languages/language";
import 'antd/lib/modal/style/css';
import Webcam from "react-webcam";
import {isMobile} from "../../Helpers/utils";

class PictureModal extends React.Component
{
    webcamRef=React.createRef();

    capture=()=>
    {
        this.props.onOK(this.webcamRef.current.getScreenshot({width:300,height:200}));
    };

    render()
    {
        let height=window.innerHeight/2;
        if(isMobile())
           height=240;
        return <Modal width={'90%'} centered visible={this.props.modalType !== null} {...this.props.modalProps}>
            <Row style={{justifyContent:'center'}} className={'text-center block'}>
                <strong>{this.props.message} </strong>
            </Row>
            <Row style={{justifyContent:'center'}} className={'text-center block'}>
                <Webcam ref={this.webcamRef} height={height} screenshotFormat="image/png" audio={false}
                videoConstraints={{facingMode:'environment'}}/>
            </Row>
            <Row style={{marginTop:'10px',justifyContent:'center'}} className={'text-center block'}>
                <Button onClick={this.capture} type={'primary'}>{language[this.props.language].takePictureLabelOk}</Button>
                <Button onClick={this.props.onCancel} type={'primary'}>{language[this.props.language].takePictureLabelCancel}</Button>
            </Row>
        </Modal>
    }
}
export default PictureModal;